var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { enumToString } from './enum';
import { countries } from './constant';
import { dayts } from './dayts';
export var hasItems = function (value) {
    if (value === void 0) { value = []; }
    return Array.isArray(value) && value.length > 0;
};
export var isDefined = function (value) { return value !== undefined && value !== null; };
export var asArray = function (value) { return (Array.isArray(value) && value) || []; };
var emailRegexFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var emailRegex = RegExp(emailRegexFormat);
var areaRegex = /^[a-zA-Z]{1,2}$/;
var postCodeRegexFormat = /^(?<district>(?<area>[a-zA-Z]{1,2})[0-9R][0-9A-Z]?)\s+[0-9][a-zA-Z]{2}$/;
var postcodeAreaRegexFormat = /^(?<district>(?<area>[a-zA-Z]{1,2})[0-9R][0-9A-Z]?)\s*$/;
export var base64ImageRegex = RegExp('data:image/([a-zA-Z]*);base64,([^"]*)');
export var getUrlRegex = function (constraint) {
    if (constraint === void 0) { constraint = '[a-z0-9]+'; }
    return RegExp("^(http://www.|https://www.|http://|https://)" + constraint + "([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$");
};
export var isRequiredValid = function (field, minLength) {
    if (minLength === void 0) { minLength = 1; }
    if (isDefined(field) && field.trim) {
        return field.trim().length >= minLength ? true : false;
    }
    return false;
};
export var isRequiredMaxLength = function (field, maxLength) {
    if (maxLength === void 0) { maxLength = Infinity; }
    if (isDefined(field))
        return field.trim().length <= maxLength ? true : false;
    return true;
};
export var isRequiredEmailValid = function (field) {
    return emailRegex.test(field);
};
export var validateRequired = function (value, name, minLength, onlyNumbers, maxLength) {
    var _a;
    if (onlyNumbers === void 0) { onlyNumbers = false; }
    var resultValue = isDefined(value) ? value.trim() : '';
    return _a = {},
        _a[name + 'Valid'] = onlyNumbers
            ? !isNaN(resultValue) &&
                isRequiredValid(resultValue, minLength) &&
                isRequiredMaxLength(resultValue, maxLength)
            : isRequiredValid(resultValue, minLength) && isRequiredMaxLength(resultValue, maxLength),
        _a;
};
export var validateRequiredEmail = function (value, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = isRequiredEmailValid(value),
        _a);
};
export var validateRequiredStrings = function (value, name, eachMinLength) {
    var _a;
    var valueString = value ? value.trim() : '';
    var valueSplit = replaceWideSpaces(valueString).split(' ');
    return _a = {},
        _a[name + 'Valid'] = valueSplit.length > 1 && valueSplit.every(function (x) { return isRequiredValid(x ? x.trim() : x, eachMinLength); }),
        _a;
};
export var validateTrue = function (value, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = value === true,
        _a);
};
export var validateAtLeastOneRequired = function (values, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = values.some(function (x) { return isRequiredValid(x); }),
        _a);
};
export var validateEnum = function (value, enumType, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = value
            ? isRequiredValid(value.trim()) &&
                enumToString(enumType).some(function (x) { return x.trim().toLowerCase() === value.trim().toLowerCase(); })
            : false,
        _a);
};
export var validateDate = function (value, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = isDefined(value) && dayts(value).isValid(),
        _a);
};
export var validateTime = function (value, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = isDefined(value) && !isNaN(value.hour) && !isNaN(value.minute),
        _a);
};
export var validatePropertyExist = function (object, value, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = isDefined(object) && Object.getOwnPropertyNames(object).some(function (x) { return x === value; }),
        _a);
};
export var validatePostcode = function (field, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = postCodeRegexFormat.test(field),
        _a);
};
export var validateArea = function (field, name) {
    var _a;
    return (_a = {},
        _a[name + 'Valid'] = areaRegex.test(field),
        _a);
};
export var getPostcodeParts = function (field) {
    var result = postCodeRegexFormat.exec(field);
    return (result && result.groups ? result.groups : {});
};
var createPostcodeParts = function (area, district, postcode) { return ({
    area: area,
    district: district,
    postcode: postcode
}); };
export var toPostcodeSearch = function (_a) {
    var _b, _c, _d, _e, _f;
    var area = _a.area, district = _a.district, postcode = _a.postcode;
    if (!postcode && district) {
        var results = postcodeAreaRegexFormat.exec(district);
        var groups = (results && results.groups ? results.groups : {});
        if (groups.area && groups.district) {
            return createPostcodeParts((_b = groups.area) === null || _b === void 0 ? void 0 : _b.toLowerCase(), (_c = groups.district) === null || _c === void 0 ? void 0 : _c.toLowerCase(), '');
        }
    }
    if (postcode) {
        var parts = getPostcodeParts(postcode);
        if (parts.area && parts.district) {
            return createPostcodeParts((_d = parts.area) === null || _d === void 0 ? void 0 : _d.toLowerCase(), (_e = parts.district) === null || _e === void 0 ? void 0 : _e.toLowerCase(), postcode === null || postcode === void 0 ? void 0 : postcode.toLowerCase());
        }
    }
    var areaResult = areaRegex.exec(area) || [];
    return createPostcodeParts((_f = areaResult[0]) === null || _f === void 0 ? void 0 : _f.toLowerCase());
};
export var objectify = function (item, value) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    item = isDefined(item) ? item : {};
    if (hasItems(args)) {
        if (args.length > 1) {
            var fieldName = args.shift();
            if (fieldName) {
                item[fieldName] = objectify.apply(void 0, __spreadArrays([item[fieldName], value], args));
            }
        }
        else {
            item[args[0]] = value;
        }
    }
    return item;
};
export var isPathDefined = function (item) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var result = isDefined(item);
    if (!result)
        return false;
    if (hasItems(args)) {
        if (args.length > 1) {
            var fieldName = args.shift();
            if (fieldName) {
                return isPathDefined.apply(void 0, __spreadArrays([item[fieldName]], args));
            }
        }
        return isDefined(item[args[0]]);
    }
    return true;
};
export var asString = function (value) {
    if (typeof value === 'string' && value) {
        return value;
    }
    else if (typeof value === 'number') {
        return value.toString();
    }
    return '';
};
var Time = (function () {
    function Time(hour, minute) {
        var h = isNaN(hour) ? 0 : hour;
        if (h && h < 24 && h >= 0) {
            this.hour = Math.floor(h);
        }
        else {
            this.hour = 0;
        }
        var m = isNaN(minute) ? 0 : minute;
        if (m && m < 60 && m >= 0) {
            this.minute = Math.floor(m);
        }
        else {
            this.minute = 0;
        }
    }
    return Time;
}());
export { Time };
export var toHourString = function (time) {
    if (time === void 0) { time = { hour: undefined, minute: undefined }; }
    return new Time(time.hour, time.minute).hour.toString().padStart(2, '0');
};
export var toMinuteString = function (time) {
    if (time === void 0) { time = { hour: undefined, minute: undefined }; }
    return new Time(time.hour, time.minute).minute.toString().padStart(2, '0');
};
export var toTimeString = function (time) {
    if (time === void 0) { time = { hour: undefined, minute: undefined }; }
    return toHourString(time) + ":" + toMinuteString(time);
};
export var toTime = function (input) {
    if (!isDefined(input))
        return time();
    if (input instanceof Date) {
        var day = dayts(input);
        return time(day.get('h'), day.get('m'));
    }
    if (typeof input === 'string' && input.trim().length === 5) {
        var hour_1 = Number(input.substr(0, 2));
        var minute_1 = Number(input.substr(3, 2));
        if (!isNaN(hour_1) && !isNaN(minute_1)) {
            return time(hour_1, minute_1);
        }
    }
    if (dayts(input).isValid()) {
        var day = dayts(input);
        return time(day.get('h'), day.get('m'));
    }
    var _a = input || {}, _b = _a.hour, hour = _b === void 0 ? undefined : _b, _c = _a.minute, minute = _c === void 0 ? undefined : _c;
    return time(hour, minute);
};
export var time = function (hour, minute) { return new Time(hour, minute); };
export var isBefore = function (before, after) {
    return before.hour < after.hour || (before.hour === after.hour && before.minute < after.minute);
};
export var isAfter = function (before, after) {
    return before.hour > after.hour || (before.hour === after.hour && before.minute > after.minute);
};
export var addTime = function (time, value, unit) {
    if (unit === void 0) { unit = 'm'; }
    if (isDefined(time) && isDefined(time.hour) && isDefined(time.minute)) {
        var day = toDate({ time: time }).add(value, unit);
        return new Time(day.get('h'), day.get('m'));
    }
    return new Time();
};
export var timeDiff = function (before, after, unit) {
    var timeBefore = toDate({ time: before });
    var timeAfter = toDate({ time: after });
    if (timeBefore && timeAfter) {
        return Math.abs(timeBefore.diff(timeAfter, unit));
    }
    return undefined;
};
export var toDate = function (_a) {
    var time = _a.time;
    if (!isDefined(time))
        return undefined;
    return dayts(Date.now()).set('h', time.hour).set('m', time.minute);
};
export var minutesToTime = function (minutes) {
    if (!Number(minutes))
        return time(0, 0);
    return time(Math.trunc(minutes / 60), minutes % 60);
};
export var wideSpaceRegex = /  +/g;
export var replaceWideSpaces = function (prop) { return (prop ? prop.replace(wideSpaceRegex, ' ') : ''); };
export var emptySpaceRegex = / +/g;
export var replaceEmptySpaces = function (prop) { return (prop ? prop.replace(emptySpaceRegex, '') : prop); };
export var capitalizeFirstLetterRegex = /\b\w/g;
export var capitalizeFirstLetter = function (prop) {
    return prop ? prop.replace(capitalizeFirstLetterRegex, function (txt) { return txt.toUpperCase(); }) : '';
};
export var trimAddressField = function (prop) {
    return prop && prop.trim().length > 0 ? "" + prop.trim() : '';
};
export var toAddressString = function (address, exclude) {
    if (exclude === void 0) { exclude = []; }
    if (isDefined(address)) {
        var addressList = [];
        var countryName = countries[address.country];
        var addressLine1 = exclude.includes('addressLine1') ? '' : toSubAddress(address.addressLine1);
        if (addressLine1) {
            addressList.push(addressLine1);
        }
        var streetAddress = exclude.includes('streetAddress') ? '' : toSubAddress(address.streetAddress);
        if (streetAddress) {
            addressList.push(streetAddress);
        }
        var townCity = exclude.includes('townCity') ? '' : toSubAddress(address.townCity);
        if (townCity) {
            addressList.push(townCity);
        }
        var county = exclude.includes('county') ? '' : toSubAddress(address.county);
        if (county) {
            addressList.push(county);
        }
        var postCode = exclude.includes('postCode') ? '' : trimAddressField(address.postCode).toUpperCase();
        if (postCode) {
            addressList.push(postCode);
        }
        var country = exclude.includes('country') ? '' : trimAddressField(countryName);
        if (country) {
            addressList.push(country);
        }
        return addressList;
    }
    return [''];
};
export var toSubAddress = function (partAddress) {
    return capitalizeFirstLetter(replaceWideSpaces(trimAddressField(partAddress)));
};
export var toAddressFormats = function (address) {
    var noStreetAddress = toAddressString(address, ['addressLine1']);
    noStreetAddress.shift();
    return [
        toAddressString(address).join(', '),
        toAddressString(address, ['addressLine1']).join(', '),
        noStreetAddress.join(', '),
        toSubAddress(address.postCode)
    ];
};
export var weekendsNear = function (day) {
    var initDay = dayts(day);
    var monday = initDay.startOf('w');
    return {
        saturday: monday.add(5, 'd'),
        sunday: monday.add(6, 'd')
    };
};
export var generateTimeSlots = function (interval) {
    if (interval === void 0) { interval = 1; }
    var timeSlots = [];
    for (var hour = 0; hour < 24; ++hour) {
        for (var minute = 0; minute < 60; minute = minute + interval) {
            timeSlots.push(time(hour, minute));
        }
    }
    return timeSlots;
};
export var toISOString = function (date) {
    return Number.isInteger(date) && dayts.unix(date).isValid() ? dayts.unix(date).toISOString() : undefined;
};
export var toDateFormat = function (date, template) {
    return Number.isInteger(date) && dayts.unix(date).isValid() ? dayts.unix(date).format(template) : '';
};
export var toCurrency = function (value) { return (!isNaN(value) ? (value / 100).toFixed(2) : '0.00'); };
export var weakMap = function () {
    var map = new WeakMap();
    return function (obj) {
        var props = map.get(obj);
        if (!props) {
            props = {};
            map.set(obj, props);
        }
        return props;
    };
};
export var arrayToObject = function (array, prop) {
    if (prop === void 0) { prop = 'id'; }
    return array.reduce(function (obj, item) {
        if (obj && item) {
            obj[item[prop]] = item;
        }
        return obj;
    }, {});
};
export var groupBy = function (array, prop) {
    if (array === void 0) { array = []; }
    if (prop === void 0) { prop = 'id'; }
    return array.reduce(function (group, item) {
        if (item === null || item === void 0 ? void 0 : item[prop])
            (group[item === null || item === void 0 ? void 0 : item[prop]] = group[item === null || item === void 0 ? void 0 : item[prop]] || []).push(item);
        return group;
    }, {});
};
export var fromDictionary = function (group, prop) {
    if (group === void 0) { group = {}; }
    var results = [];
    for (var key in group) {
        if (Object.prototype.hasOwnProperty.call(group, key)) {
            var element = group[key];
            if (prop && typeof prop === 'string' && (typeof element === 'object' || typeof element === 'function')) {
                element[prop] = key;
            }
            if (element) {
                results.push(element);
            }
            else if (prop && typeof prop === 'string') {
                element = {};
                element[prop] = key;
                results.push(element);
            }
        }
    }
    return results;
};
export var random = function (min, max, digits) {
    var generated = Math.floor(Math.random() * (max - min) + min);
    return isDefined(digits) ? generated.toString().padStart(digits, '0') : generated;
};
export var isAnyTrue = function (props) {
    if (props === void 0) { props = []; }
    return props.some(function (x) { return x === true; });
};
export var update = function (list, index, selected) {
    if (!Array.isArray(list))
        return list;
    if ((isDefined(index) && !Number.isInteger(index)) || !isDefined(index))
        return list;
    if (index < 0 || index > list.length - 1)
        return list;
    if (!selected)
        return list;
    return __spreadArrays(list.slice(0, index), [selected], list.slice(index + 1));
};
export var remove = function (list, index) {
    if (!Array.isArray(list))
        return list;
    if ((isDefined(index) && !Number.isInteger(index)) || !isDefined(index))
        return list;
    if (index < 0 || index > list.length - 1)
        return list;
    return __spreadArrays(list.slice(0, index), list.slice(index + 1));
};
export var pluck = function (o, propertyNames) {
    return o ? propertyNames.map(function (n) { return o[n]; }) : [];
};
//# sourceMappingURL=helper.js.map